import React, { forwardRef } from 'react'
import { FieldTypes } from 'utils/formUtils';
import RedlockMappingForm from './RedlockMappingForm';
import { urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import { SUPPORT_URL } from '../twistlock/TwistLockCredentialsForm';

function RedlockCredentialsForm(props, ref) {
    const fields = [{
        name: "apiEndpoint",
        label: "API Endpoint",
        required: true,
        rules:[urlRegexValidator],
        help: SUPPORT_URL,
    },
    {
        name: "adminConsoleUrl",
        label: "Admin Console URL",
        help: <>Please enter your Prisma Tenant URL (For example: <a href="https://app2.prismacloud.io" target="_blank"  rel="noopener noreferrer">https://app2.prismacloud.io</a>)</>,
        required: true,
        rules:[urlRegexValidator],
    },
    {
        name: "username",
        label: "Access Key",
        required: true
    }, 
    {
        name: "password",
        label: "Secret Key",
        type: FieldTypes.PASSWORD,
        required: true
    }]

    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={RedlockMappingForm}
        />
    )
}

export default forwardRef(RedlockCredentialsForm);